




































































import { Component, Vue } from "vue-property-decorator";
import { IGoogleFont } from "@/models/google";
import { ITag } from "@/models/tags";
import { IState } from "@/store";

@Component({
  components: {
    "font-grid-item": () =>
      import("@/components/app/admin/settings/brands/fonts/fontGridItem.vue"),
    "tags-cloud-view": () =>
      import("@/components/app/global/tags/tagsCloudView.vue")
  }
})
export default class SelectFontModal extends Vue {
  // Data

  public googleFonts: IGoogleFont[] = [];
  public isLoading = true;
  public limit = 20;
  public page = 1;
  public sampleMessage = null;
  public searchQuery = "";
  public selectedCategories: string[] = [];

  // Life-cycle methods

  public async created() {
    try {
      this.googleFonts = await this.getGoogleFonts();
    } finally {
      this.isLoading = false;
    }
  }

  // Computed

  public get brand() {
    return (this.$store.state as IState).brand;
  }

  public get pageData() {
    const start = (this.page - 1) * this.limit;
    return this.filteredFonts.slice(start, start + this.limit);
  }

  public get selectedTags() {
    return this.selectedCategories.map(i =>
      this.availableTags.find(tag => tag.id === i)
    );
  }

  public get filteredFonts() {
    return this.googleFonts.filter(
      font =>
        (this.selectedCategories.length
          ? this.selectedCategories.includes(font.category)
          : true) &&
        (this.searchQuery?.length
          ? font.family
              .toLocaleLowerCase()
              .includes(this.searchQuery.toLocaleLowerCase())
          : true)
    );
  }

  public get availableTags(): ITag[] {
    const res = this.googleFonts.reduce((acc, font) => {
      this.$set(acc, font.category, {
        id: font.category,
        name: this.$_.upperFirst(font.category),
        colour: "#018ffd"
      } as ITag);
      return acc;
    }, {});

    return this.$_.toArray(res);
  }

  // Methods

  public toggleTag(tag: ITag) {
    const index = this.selectedCategories.findIndex(i => i === tag.id);
    if (index === -1) this.selectedCategories.push(tag.id);
    else this.selectedCategories.splice(index, 1);
    this.onPageChange(1);
  }

  public getGoogleFonts() {
    return this.$store.dispatch(`brand/getGoogleFonts`, {
      vm: this
    });
  }

  public clearSearch() {
    this.onPageChange(1);
    this.searchQuery = "";
  }

  public onSelectFont(font: IGoogleFont) {
    this.$emit("select", font);
    this.$emit("close");
  }

  public onPageChange(page) {
    this.page = page;
    this.scrollToTop();
  }

  public onLimitChange(limit) {
    this.limit = limit;
    this.page = 1;
  }

  public scrollToTop() {
    this.$scrollTo("#scrollTarget", {
      container: ".modal-card-body",
      offset: -32,
      duration: 250
    });
  }
}
